<!-- This is one icon to control all icons -->

<script setup>
import { defineProps } from "vue";

import {
  BIconBoxArrowRight,
  BIconLock,
  BIconArrowClockwise,
  BIconClock,
  BIconHandThumbsUp,
  BIconHandThumbsDown,
  BIconChatSquareDots,
  BIconArrowRightCircle,
  BIconCaretRightFill,
  BIconPaperclip,
  BIconCardImage,
  BIconEye,
  BIconEyeSlash,
  BIconDownload,
  BIconTools,
  BIconStopCircle,
  BIconPlayCircleFill,
} from "bootstrap-icons-vue";

import IconFeedback from "@/components/ui-kit/base/IconFeedback.vue";
import IconAIFill from "@/components/ui-kit/base/IconAIFill.vue";
import IconTicket from "@/components/ui-kit/base/IconTicket.vue";

import IconAILinear from "./IconAILinear.vue";
import IconAnalytics from "./IconAnalytics.vue";
import IconArrowDown from "./IconArrowDown.vue";
import IconArrowLeftCircle from "./IconArrowLeftCircle.vue";
import IconArrowLoading from "./IconArrowLoading.vue";
import IconArrowUp from "./IconArrowUp.vue";
import IconBluePlusSquare from "./IconBluePlusSquare.vue";
import IconCheck from "./IconCheck.vue";
import IconCheckbox from "./IconCheckbox.vue";
import IconCheckboxChecked from "./IconCheckboxChecked.vue";
import IconCheckboxPartial from "./IconCheckboxPartial.vue";
import IconCheckMark from "./IconCheckMark.vue";
import IconChevronDown from "./IconChevronDown.vue";
import IconChrome from "./IconChrome.vue";
import IconCircle from "./IconCircle.vue";
import IconCircleFill from "./IconCircleFill.vue";
import IconClose from "./IconClose.vue";
import IconComment from "./IconComment.vue";
import IconCommunity from "./IconCommunity.vue";
import IconCompany from "./IconCompany.vue";
import IconConfidenceRobot from "./IconConfidenceRobot.vue";
import IconCSV from "./IconCSV.vue";
import IconCustomerRequest from "./IconCustomerRequest.vue";
import IconDashPartial from "./IconDashPartial.vue";
import IconDocumentation from "./IconDocumentation.vue";
import IconDraft from "./IconDraft.vue";
import IconEcosystem from "./IconEcosystem.vue";
import IconEmail from "./IconEmail.vue";
import IconExcel from "./IconExcel.vue";
import IconExport from "./IconExport.vue";
import IconEyeClosed from "./IconEyeClosed.vue";
import IconEzeeAssist from "./IconEzeeAssist.vue";
import IconFileUploaderContainer from "./IconFileUploaderContainer.vue";
import IconFilter from "./IconFilter.vue";
import IconForward from "./IconForward.vue";
import IconFrame from "./IconFrame.vue";
import IconGear from "./IconGear.vue";
import IconImport from "./IconImport.vue";
import IconInbox from "./IconInbox.vue";
import IconIncomingArrow from "./IconIncomingArrow.vue";
import IconInfo from "./IconInfo.vue";
import IconLogo from "./IconLogo.vue";
import IconMessages from "./IconMessages.vue";
import IconMeta from "./IconMeta.vue";
import IconMSTeams from "./IconMSTeams.vue";
import IconOutComingArrow from "./IconOutComingArrow.vue";
import IconPencil from "./IconPencil.vue";
import IconPerson from "./IconPerson.vue";
import IconPersonCheck from "./IconPersonCheck.vue";
import IconPlusSquare from "./IconPlusSquare.vue";
import IconRead from "./IconRead.vue";
import IconRedTrash from "./IconRedTrash.vue";
import IconResetPasswordCheckMark from "./IconResetPasswordCheckMark.vue";
import IconRobot from "./IconRobot.vue";
import IconSadBeam from "./IconSadBeam.vue";
import IconSearch from "./IconSearch.vue";
import IconSlack from "./IconSlack.vue";
import IconSmileBeam from "./IconSmileBeam.vue";
import IconSMS from "./IconSMS.vue";
import IconSort from "./IconSort.vue";
import IconSupport from "./IconSupport.vue";
import IconThreeDotsVertical from "./IconThreeDotsVertical.vue";
import IconTooling from "./IconTooling.vue";
import IconTraining from "./IconTraining.vue";
import IconTrash from "./IconTrash.vue";
import IconTrashWithoutBorders from "./IconTrashWithoutBorders.vue";
import IconWhatsapp from "./IconWhatsapp.vue";
import IconWordpress from "./IconWordpress.vue";
import IconPatent from "./IconPatent.vue";
import OrgInitialsIcon from "./OrgInitialsIcon.vue.vue";

const props = defineProps({
  icon: {
    type: String,
    default: "gear",
  },
  iconProps: {
    type: Object,
    default: {},
  },
});

const iconComponent = computed(() => {
  switch (props.icon) {
    case "ai":
      return IconAILinear;
    case "ai-fill":
      return IconAIFill;
    case "analytics":
      return IconAnalytics;
    case "arrow-clockwise":
      return BIconArrowClockwise;
    case "arrow-down":
      return IconArrowDown;
    case "arrow-incoming":
      return IconIncomingArrow;
    case "arrow-left-circle":
      return IconArrowLeftCircle;
    case "arrow-loading":
      return IconArrowLoading;
    case "arrow-up":
      return IconArrowUp;
    case "arrow-right-box":
      return BIconBoxArrowRight;
    case "blue-plus-square":
      return IconBluePlusSquare;
    case "check":
      return IconCheck;
    case "checkbox":
      return IconCheckbox;
    case "checkbox-checked":
      return IconCheckboxChecked;
    case "checkbox-partial":
      return IconCheckboxPartial;
    case "check-mark":
      return IconCheckMark;
    case "chevron-down":
      return IconChevronDown;
    case "chrome":
      return IconChrome;
    case "clock":
      return BIconClock;
    case "web":
      return IconChrome;
    case "circle":
      return IconCircle;
    case "circle-fill":
      return IconCircleFill;
    case "close":
      return IconClose;
    case "comment":
      return IconComment;
    case "community":
      return IconCommunity;
    case "company":
      return IconCompany;
    case "confience-robot":
      return IconConfidenceRobot;
    case "csv":
      return IconCSV;
    case "customer-request":
      return IconCustomerRequest;
    case "dash-partial":
      return IconDashPartial;
    case "documentation":
      return IconDocumentation;
    case "download":
      return BIconDownload;
    case "draft":
      return IconDraft;
    case "ecosystem":
      return IconEcosystem;
    case "email":
      return IconEmail;
    case "excel":
      return IconExcel;
    case "export":
      return IconExport;
    case "eye-closed":
      return IconEyeClosed;
    case "ezee-assist":
      return IconEzeeAssist;
    case "feedback":
      return IconFeedback;
    case "file-uploader-container":
      return IconFileUploaderContainer;
    case "filter":
      return IconFilter;
    case "forward":
      return IconForward;
    case "frame":
      return IconFrame;
    case "gear":
      return IconGear;
    case "import":
      return IconImport;
    case "inbox":
      return IconInbox;
    case "info":
      return IconInfo;
    case "logo":
      return IconLogo;
    case "lock":
      return BIconLock;
    case "messages":
      return IconMessages;
    case "meta":
      return IconMeta;
    case "msteams":
      return IconMSTeams;
    case "arrow-outgoing":
      return IconOutComingArrow;
    case "pencil":
      return IconPencil;
    case "person":
      return IconPerson;
    case "person-check":
      return IconPersonCheck;
    case "plus-square":
      return IconPlusSquare;
    case "read":
      return IconRead;
    case "reset-password-checkmark":
      return IconResetPasswordCheckMark;
    case "robot":
      return IconRobot;
    case "sad-beam":
      return IconSadBeam;
    case "search":
      return IconSearch;
    case "slack":
      return IconSlack;
    case "smile-beam":
      return IconSmileBeam;
    case "sms":
      return IconSMS;
    case "sort":
      return IconSort;
    case "support":
      return IconSupport;
    case "three-dots-vertical":
      return IconThreeDotsVertical;
    case "thumbs-up":
      return BIconHandThumbsUp;
    case "thumbs-down":
      return BIconHandThumbsDown;
    case "ticket":
      return IconTicket;
    case "tooling":
      return IconTooling;
    case "training":
      return IconTraining;
    case "trash":
      return IconTrash;
    case "trash-without-borders":
      return IconTrashWithoutBorders;
    case "trash-red":
      return IconRedTrash;
    case "whatsapp":
      return IconWhatsapp;
    case "wordpress":
      return IconWordpress;
    case "initials":
      return OrgInitialsIcon;
    case "messenger":
      return BIconChatSquareDots;
    case "wfb-agent-chat":
      return BIconTools;
    case "arrow-right-circled":
      return BIconArrowRightCircle;
    case "arrow-right":
      return BIconCaretRightFill;
    case "stop-circled":
      return BIconStopCircle;
    case "paperclip":
      return BIconPaperclip;
    case "play-circle":
      return BIconPlayCircleFill;
    case "card-image":
      return BIconCardImage;
    case "eye":
      return BIconEye;
    case "eye-slash":
      return BIconEyeSlash;
    case "content-recommendations":
      return IconPatent;
    default:
      return IconGear;
  }
});
</script>

<template>
  <component :is="iconComponent" v-bind="iconProps" />
</template>
